import {
  postData,
  putData,
  getData,
  deleteData
} from './request'

// 获取team
export function getTeams({offset,count}, cb) {
  return getData(`/api/v3/groups?include=recent_member&ignore=tmp,special&offset=${offset}&count=${count}`, {}, cb)
}

// 创建团队
export function createTeam(paload,cb){
  return postData(`/api/v3/groups`,paload,{},cb)
}

// 重命名
export function rename(paload,cb){
  return putData(`/api/v3/groups/${paload.groupid}`, paload, {}, cb)
}

// 获取团队信息
export function getDetail(tid,cb){
  return getData(`/api/v3/mine/team/${tid}?withmember=true`, {}, cb)
}
// 团队邀请链接
export function getLink(tid,cb){
  // return getData(`/myapi/invitelink/${tid}`, {}, cb)
  return getData(`/api/v3/groups/${tid}/invite_info`, {}, cb)
}
// 团队路径
export function loadPath({tid,fid},cb){
  return getData(`/myapi/info/${fid}/${tid}`,{},cb)
}
// 退出团队
export function exitTeam({groupid,role,memberid},cb){
  let url = role == 'creator' ? `/api/v3/groups/${groupid}` : `/api/v3/groups/${groupid}/members/${memberid}`
  return deleteData(url, null, {}, cb)
}
// 加载团队头像
export function loadAvatars(ids,cb){
  return getData(`/api/v3/groups/members_info?groups=${ids}`, {}, cb)
}

// 获取团队成员
export function loadMembers({groupid,offset,count},cb){
  return getData(`/api/v3/groups/${groupid}/members?offset=${offset}&count=${count}`, {}, cb)
}

// 设置链接邀请
export function linkSetting(paload, cb) {
  return putData(`/api/v3/groups/link/${paload.groupid}/settings`, paload, {}, cb)
}
// 设置用户权限
export function switchPermission(paload, cb) {
  return putData(`/api/v3/groups/${paload.groupid}/members/${paload.id}`, paload, {}, cb)
}

// 移出团队
export function removeMember(paload,cb){
  return deleteData(`/api/v3/groups/${paload.groupid}/members/${paload.memberid}`, null, {}, cb)
}

// 根据key获取团队信息
export function getTeamInfo(key,cb){
  return getData(`/api/v3/team/link/${key}`,{},cb)
}

// 加入团队
export function joinTeam(key,cb){
  return postData(`/api/v3/mine/team/link/${key}/join`,{key},{},cb)
}


// WEBPACK FOOTER //
// ./src/store/service/team.js